import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UserRoles from "constants/UserRoles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const breadcrumbsStatic = [{
	name: 'Refunds',
	url: '/refunds',
	icon: 'users',
}];

export default class Refunds extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {
		let {history} = this.props;

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					<Button data-cy="add-customer" onClick={this.toggle('modalRefundAdd')} size={"sm"} color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Add Refund
					</Button>
				</Framework.Components.PageBar>

				<Framework.Elements.UniversalModal
					name={"New Refund"}
					object={Objects.Refund}
					toggle={this.state.modalRefundAdd}
					reportClose={this.reportClose('modalRefundAdd')}
					afterSave={() => this.refreshPage()}
					hideGoTo={true}
					hasDelete={false}
				/>

				<Collections.Refunds
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
				/>

			</div>
		);
	}
}

